import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Primary
var headingFont = 'Poppins", "Helvetica", "Arial", sans-serif;';
var bodyFont = 'Raleway", "Helvetica", "Arial", sans-serif;';

//Returning the component
class GlobalFonts extends Component {
	render() {
		return (
			<div>
				<div>Heading font: {headingFont}</div>
				<div><em>Heading font italic: {headingFont}</em></div>
				<div><strong>Heading font bold: {headingFont}</strong></div>
				<div>Body font: {bodyFont}</div>
				<div><em>Body font italic: {bodyFont}</em></div>
				<div><strong>Body font bold: {bodyFont}</strong></div>
			</div>
		)
	}
}

export default GlobalFonts;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/GlobalFonts.jsx